export function isZh(value) {
  value = value.replace(/(^\s*)|(\s*$)/, '').replace(/_/,'-')
  const reg = /zh-(cn|hk|mo|sg|tw|chs|cht)/i
	return reg.test(value)
}
